<template>
  <div id="index">
    <el-container>
      <el-scrollbar :class="isCollapse ? 'menu_hide rightSide' : 'rightSide'">
        <el-main>
          <el-breadcrumb
            separator-class="el-icon-arrow-right"
            class="mainBread"
          >
            <el-breadcrumb-item>{{ $t("menu.Home_View") }}</el-breadcrumb-item>
            <el-breadcrumb-item>{{
              $t("web.DeviceMonitorManagement_View")
            }}</el-breadcrumb-item>
          </el-breadcrumb>
          <el-form
            ref="formselect"
            :model="formselect"
            class="queryform_div"
            label-width="135px"
          >
            <el-row :gutter="24">
              <el-col :xs="24" :sm="12" :md="8">
                <el-form-item :label="$t('desc.project')">
                  <el-select
                    v-model="formselect.value4"
                    filterable
                    collapse-tags
                    style="width: 100%"
                    :placeholder="$t('desc.select')"
                    size="small"
                    @change="changeCust"
                  >
                    <el-option value="全部" :label="$t('desc.all')"></el-option>
                    <el-option
                      v-for="item in custOptions"
                      :key="item.id"
                      :label="item.customerName"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="8">
                <el-form-item :label="$t('title.machineType')">
                  <el-select
                    v-model="formselect.value5"
                    filterable
                    collapse-tags
                    style="width: 100%"
                    :placeholder="$t('desc.select')"
                    size="small"
                    @change="changeModel"
                  >
                    <el-option value="全部" :label="$t('desc.all')"></el-option>
                    <el-option
                      v-for="item in deviceModelArrShow"
                      :key="item.id"
                      :label="item.modelDesc"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="8">
                <el-form-item :label="$t('desc.airCompressorSN')">
                  <el-select
                  @change="$forceUpdate()"
                    v-model="formselect.value3"
                    filterable
                    collapse-tags
                    :placeholder="$t('desc.select')"
                    style="width: 100%"
                    size="small"
                  >
                    <el-option value="全部" :label="$t('desc.all')"></el-option>
                    <el-option
                      v-for="(item ,index) in deviceListShow"
                      :key="item.id"
                      :label="item.dsn"
                      :value="item.dsn"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="8">
                <el-form-item :label="$t('title.AirCompressorStatus')">
                  <el-select
                    v-model="formselect.value6"
                    filterable
                    collapse-tags
                    :placeholder="$t('desc.select')"
                    style="width: 100%"
                    size="small"
                  >
                    <el-option value="全部" :label="$t('desc.all')"></el-option>
                    <el-option value="运行" :label="$t('desc.run')"></el-option>
                    <el-option
                      value="停机"
                      :label="$t('desc.stop')"
                    ></el-option>
                    <el-option
                      value="加载"
                      :label="$t('desc.load')"
                    ></el-option>
                    <el-option
                      value="卸载"
                      :label="$t('desc.Unload')"
                    ></el-option>
                    <el-option
                      value="警告"
                      :label="$t('tips.warning')"
                    ></el-option>
                    <el-option
                      value="故障"
                      :label="$t('title.trip')"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="8">
                <el-form-item :label="$t('title.gatewaystatus')">
                  <el-select
                    v-model="formselect.value7"
                    filterable
                    collapse-tags
                    :placeholder="$t('desc.select')"
                    style="width: 100%"
                    size="small"
                  >
                    <el-option value="99" :label="$t('desc.all')"></el-option>
                    <el-option :label="$t('desc.normal')" value="1"></el-option>
                    <el-option
                      :label="$t('tips.warning')"
                      value="2"
                    ></el-option>
                    <el-option
                      :label="$t('desc.offline')"
                      value="-1"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :md="24" :sm="24" :xs="24">
                <el-form-item>
                  <el-button
                    @click="getDeviceTable('search')"
                    type="primary"
                    size="small"
                    >{{ $t("button.query") }}</el-button
                  >

                  <el-button @click="resetKeyword" size="small">{{
                    $t("button.reset")
                  }}</el-button>
                  <el-button
                    icon="fa fa-area-chart"
                    type="primary"
                    style="float: right"
                    @click="openMonitor(true)"
                    size="small"
                    >{{ $t("web.viewMonitor") }}</el-button
                  >
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>

          <div class="clear"></div>
          <template>
            <template v-for="item in deviceTableShow">
              <div
                class="KList"
                style="margin-bottom: 10px"
                @click="getDeviceByDsn(item.dsn,item.gsn,item.compressorNumber)"
                :key="item.id"
              >
                <el-row :gutter="24">
                  <el-col
                    :xs="24"
                    :sm="8"
                    :md="4"
                    style="
                      text-align: center;
                      padding-left: 15px !important;
                      padding-right: 0px !important;
                    "
                  >
                    <img
                      :src="item.imgUrl ? item.imgUrl : k1"
                      style="width: 85%; max-width: 300px"
                    />
                    <img
                      src="~assets/img/logo.png"
                      style="width: 60px; margin-bottom: 5px"
                    />
                  </el-col>
                  <el-col
                    :xs="24"
                    :sm="16"
                    :md="20"
                    style="
                      border-left: 1px solid #414248;
                      padding-left: 30px !important;
                      padding-right: 45px !important;
                    "
                  >
                    <div class="header">
                      <el-row :gutter="24" class="info">
                        <el-col :xs="24" :sm="12" :md="8">
                          <h4>{{ $t("desc.airCompressorSN") }}：{{ item.dsn }}</h4>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="8">
                          <h4>{{ $t("desc.compressorNumber") }}：{{ item.compressorNumber }}</h4>
                        </el-col>
                      </el-row>
                      <el-row :gutter="24" class="info">
                        <el-col :xs="24" :sm="12" :md="8">
                          <span>{{ $t("title.productLine") }}：</span
                          >{{ item.kType }}
                        </el-col>
                        <!-- <el-col :xs="24" :sm="12" :md="6">
                          <span>{{ $t("title.productCategories") }}：</span
                          >{{ item.kProduct }}
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="6">
                          <span>{{ $t("title.smallClassProduct") }}：</span
                          >{{ item.kSmall }}
                        </el-col> -->
                        <el-col :xs="24" :sm="12" :md="8">
                          <span>{{ $t("title.machineType") }}：</span
                          >{{ item.kPower }}
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="8">
                          <span>{{ $t("title.airCompressorService") }}：</span>
                          {{ item.serviceType }}
                        </el-col>
                      </el-row>
                    </div>

                    <div class="body state">
                      <el-row :gutter="24">
                        <el-col :xs="24" :sm="12" :md="6">
                          <span
                            >{{ $t("title.AirCompressorStatus") }}：
                            <strong
                              class="numcircle"
                              :style="
                                !item.compressorState
                                  ? 'background-color:#9ba2ac'
                                  : item.compressorState.indexOf('警告') != -1
                                  ? 'background-color:#EFCA3F'
                                  : (item.compressorState.indexOf('停机') != -1 || item.compressorState.indexOf('故障') != -1)
                                  ? 'background-color:#F8454D'
                                  : item.compressorState.indexOf($t('tips.NA')) != -1
                                  ? 'background-color:#9ba2ac'
                                  : 'background-color:#62CF88'
                              "
                              >{{
                                item.compressorState
                                  ? (activeLang=='zh'?item.compressorState:$t("desc."+item.compressorState.trim()))
                                  : $t("tips.NA")
                              }}</strong
                            >
                          </span>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="6">
                          <span
                            >{{ $t("title.RunningTime") }}：
                            <strong class="numcircle">{{
                              item.runningHour ? (item.runningHour +" h") : $t("tips.NA")
                            }}</strong>
                          </span>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="6">
                          <span
                            >{{ $t("title.DischargePressure") }}：
                            <strong class="numcircle">{{
                              item.dischargePressure ? item.dischargePressure : $t("tips.NA")
                            }}</strong>
                          </span>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="6">
                          <span
                            >{{ $t("title.RatedPressure") }}：
                            <strong class="numcircle">{{
                              item.ratedPressure ? item.ratedPressure : $t("tips.NA")
                            }}</strong>
                          </span>
                        </el-col>
                      </el-row>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </template>
            <el-pagination 
              :page-size="pagination.pageSize"
              :page-sizes="[10, 20, 50]"
              :current-page.sync="pagination.current"
              @current-change="handleCurrentChange"
              @size-change="handleSizeChange"
              layout="prev, pager, next,sizes"
              :total="pagination.totalPage"
            >
            </el-pagination>
          </template>
        </el-main>
      </el-scrollbar>
    </el-container>
    <monitor-dialog
      ref="monitorRef"
      :dialogClient="dialogMonitor"
      :title="dialogTitle"
      :gatherOption="gatherOptionShow"
      :monitorDataList="monitorDataList"
      :activeLang="activeLang"
      :projectType ="projectType"
      @onSearchBtn="getDeviceTable"
      @dialogVisibleEvent="openMonitor"
      @showEcharts="getMonitorHistory"
    >
    </monitor-dialog>
    <monitor-deviceInfo-Dialog
      ref="deviceInfoRef"
      :dialogClient="dialogDevice"
      :title="deviceTitle"
      :cNumbertitle="cNumbertitle"
      :DeviceInfo="DeviceInfoShow"
      :CustomerInfo="CustomerInfo"
      :gatherOption="ccnGatherOption"
      :ccnCodeList222="ccnCodeList222"
      :activeLang="activeLang"
      :isDingOrBian="isDingOrBian"
      :echartID="echartID"
      :echartIDHistory="echartIDHistory"
      :maintainList="maintainList"
      :IsShowSensitive="IsShowSensitive"
      :UseRateData="UseRateData"
      @getMonitorHistoryByGsn="getMonitorHistoryByGsn"
      @dialogVisibleEvent="openDevice"
      @openCcnTable="openCcnTable"
      @getRealData="getRealData"
      @changeCode="changeCode"
      @openMaintain="openMaintainDialog"
    >
    </monitor-deviceInfo-Dialog>
    <monitor-ccn-table
      :dialogClient="dialogDeviceCCN"
      :title="tableTitle"
      :tableCCN="tableCCN"
      @dialogVisibleEvent="openCcnTable"
    >
    </monitor-ccn-table>
    <monitor-maintain-dialog
      :dialogClient="dialogMaintain"
      :title="maintainTitle"
      :serviceform="serviceform"
      :tableService="tableService"
      @dialogVisibleEvent="openMaintainDialog"
    >
    </monitor-maintain-dialog>
  </div>
</template>
<script>
import {
  getCustomerRegionTree,
  getUserCustomerList,
  GetUserDevices,
  GetUserDeviceModels,
  getMonitorHistoryForWeb,
  getDeviceDataForWeb,
  GetDevicesByCustomerAndAgencyList,
  getMonitorGathers
} from "../../api/api";
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import k1 from "../../assets/img/img_machine.png";
import monitorDialog from "../../components/content/monitor/MonitorDialog";
import monitorDeviceInfoDialog from "../../components/content/monitor/MonitorDeviceInfoDialog";
import monitorCcnTable from "../../components/content/monitor/MonitorCcnTable";
import monitorMaintainDialog from "../../components/content/monitor/MonitorMaintainDialog";
import { contratMixin } from "../../mixins/monitorWebMixin";
export default {
  name: "index",
  components: {
    "monitor-dialog": monitorDialog,
    "monitor-deviceInfo-Dialog": monitorDeviceInfoDialog,
    "monitor-ccn-table": monitorCcnTable,
    "monitor-maintain-dialog": monitorMaintainDialog,
  },
  mixins: [contratMixin],
  computed: {
    ...mapGetters({
      activeLang: "language",
    }),
    ...mapState({
      isCollapse: (state) => state.isCollapse,
    }),
  },
  data() {
    return {
      projectType:"Web",
      pacCcnFilterArr:
      ["System Pressure",
      "Stage 1 Temperature",
      "Stage 1 Vibration",
      "Stage 1 Pressure",
      "Stage 2 Temperature",
      "Stage 2 Vibration",
      "Stage 2 Pressure",
      "Stage 3 Temperature",
      "Stage 3 Vibration",
      "Stage 3 Pressure"],
      pagination: {
        current: 1,
        pageSize: 10,
        totalPage: 0,
      },
      IsShowSensitive: false,
      dialogMonitor: false,
      dialogDevice: false,
      dialogDeviceCCN: false,
      showEDiv: false,
      formselect: {},
      deviceTable: [],
      deviceTableShow: [],
      //监控页面数据
      deviceList: [],
      deviceListShow: [],
      deviceOption: [],
      gatherOption: [],
      gatherOptionShow: [],
      ccnGatherOption: [],
      monitorDataList: [],
      realMonitorData: {},
      realMonitorDataShow: {},
      echartID: {},
      //空压机详细
      DeviceInfo: {},
      CustomerInfo: {},

      regionOptions: [],
      centerOptions: [],
      custOptions: [],
      skipCount: 0,
      maxResultCount: 10,
      totalPage: 1,
      dialogTitle: "",
      tableTitle: "",
      tableCCN: [],
      isShowErr: true,
      interfaceTimes: 15,
      ccnCodeList: [],
      k1: k1,
      deviceStatuList: {
        1: "正常",
        2: "报警",
        3: "故障",
      },
      monitorHistoryData: [],
      ccnCodeList222: [],
      deviceState: "",
      infoDsn: "",
      isDingOrBian: "ding",
      echartID: {},
      echartIDHistory: {},
      stopSetTimeOut: {},
      stopDeviceData: {},
      //告警
      alarmList: [],
      UseRateData: "",
      serviceform: "",
      tableService: [],
      maintainList: [],
      dialogMaintain: false,
      maintainTitle: "",
      customerType: "",
      hisCustomer: {},
      deviceModelArr:[],
      deviceModelArrShow:[],
    };
  },
  async mounted() {
    if (this.$route.query.id) {
      this.$set(this.formselect, "value5", [this.$route.query.id]);
    }

    if (this.$route.query.customerType) {
      this.customerType = this.$route.query.customerType;
    }
    if (this.$route.params.gsnState) {
      this.$set(this.formselect, "value7", this.$route.params.gsnState);
      // this.formselect.gsnState = this.$route.params.gsnState;
    }
    this.getCustomerRegionTree();
    this.getGatherOption();
    this.getCustOption();
    this.getDeviceTable();
    this.getDeviceOption();
    this.getDeviceModelOption();
  },
  methods: {
    getCustomerRegionTree() {
      let that = this;
      getCustomerRegionTree().then((res) => {
        let data = res.result;
        that.centerOptions = data;
      });
    },
    getCustOption() {
      let that = this;
      getUserCustomerList().then((res) => {
        let data = res.result;
        that.custOptions = data;
        for (let index = 0; index < data.length; index++) {
          that.custOptions[index].customerName = data[index].customerName;
        }
      });
    },
    getGatherOption() {
      let that = this;
      getMonitorGathers().then((res) => {
        let data = res.result;
        that.gatherOption = data;
        that.gatherOptionShow = this.unique(data.filter((bbb) =>
          this.unitList.some((unit) => unit == bbb.unit)
        ));
      });
    },
    unique(arr) {//去重
      const res = new Map();
      return arr.filter((a) => !res.has(a.name) && res.set(a.name, 1));
    },
    getDeviceOption() {
      let that = this;
      GetUserDevices().then((res) => {
        let data = res.result;
        that.deviceList = data.filter((item) => item.gsn);
        that.deviceListShow = data.filter((item) => item.gsn);
      });
    },
    changeModel(){
      let that = this;
      that.formselect.value3 = "";
      if (that.formselect.value5 && that.formselect.value5 != '全部') {
        that.deviceListShow = that.deviceList.filter(a=>that.formselect.value5.includes(a.modelId) && that.formselect.value4.includes(a.customerId))
      }else{
        that.deviceListShow = JSON.parse(JSON.stringify(that.deviceList))
      }
      
    },
    changeCust(){
      let that = this;
      that.formselect.value5 = "";
      that.formselect.value3 = "";
      if (that.formselect.value4 && that.formselect.value4 != '全部'){
        that.deviceListShow = that.deviceList.filter(a=>that.formselect.value4.includes(a.customerId))
        let modelList = that.deviceListShow.map(a=>a.modelId);
        that.deviceModelArrShow = that.deviceModelArr.filter(a=>modelList.includes(a.id) && a.level == '4')
      }else{
        that.deviceListShow = JSON.parse(JSON.stringify(that.deviceList));
        that.deviceModelArrShow = JSON.parse(JSON.stringify(that.deviceModelArr))
      }
      
    },
    async getDeviceModelOption(){
      let that = this;
      let res = await GetUserDeviceModels();
      that.deviceModelArr = res.result.filter(a=>a.level == '4');
      that.deviceModelArrShow = JSON.parse(JSON.stringify(that.deviceModelArr));
    },
    getDeviceTable(type = "normal") {
      let that = this;
      if (type == "search") {
        this.pagination.current = 1;
      }
      let data = {
        ModelIdList: that.formselect.value5?[that.formselect.value5]:new Array(),
        CustomerList: that.formselect.value4?[that.formselect.value4]:new Array(),
        DsnList: that.formselect.value3?[that.formselect.value3]:new Array(),
        Language: this.activeLang,
        State: this.$route.params.type,
        GatewayState: that.formselect.value7,
        CompressorState:that.formselect.value6,
        SkipCount:(this.pagination.current - 1) * this.pagination.pageSize,
        MaxResultCount:this.pagination.pageSize
        // StateList: that.formselect.value6,
      };
      GetDevicesByCustomerAndAgencyList(data).then((res) => {
        that.pagination.totalPage = res.result.totalCount;
        that.deviceTable = res.result.items;
        that.deviceTableShow = res.result.items;
      });
    },
    getMonitorHistory(value, value2, value3, value4, type, deviceOption) {
      let that = this;
      let data = {
        gsnList: value2,
        paraList: value.value2,
        startTime: value3,
        endTime: value4,
        dateTime: value.date,
        type: type,
        language: this.activeLang,
      };
      getMonitorHistoryForWeb(data).then((res) => {
        let data = res.result;
        if (data.length === 0) {
          that.$message({
            showClose: true,
            message: "未找到监控数据",
            type: "error",
          });
          return false;
        }
        //先赋值dsn 再渲染图标
        that.monitorDataList = new Array();
        for (let index = 0; index < data.length; index++) {
          //.赋值无法监控
          data[index].dsn = deviceOption.find(
            (a) => a.gsn == data[index].gsn
          )?.dsn;
          //push赋值对象才能监控到变化
          that.monitorDataList.push(data[index]);
        }
        this.$nextTick(() => {
          setTimeout(() => {
            for (let index = 0; index < data.length; index++) {
              //.赋值无法监控
              data[index].dsn = deviceOption.find(
                (a) => a.gsn == data[index].gsn
              )?.dsn;
              //push赋值对象才能监控到变化
              that.initEcharts("Kchart_" + index, that.monitorDataList[index]);
            }
          }, 300);
        });
      });
    },
    openMonitor(visible) {
      this.dialogMonitor = visible;
      if (visible) {
        this.dialogTitle = this.$t("web.monitorChart");
        // this.deviceOption = this.deviceList;
        // this.$nextTick(()=>{
        //   this.$refs.monitorRef.showEcharts();
        // })
      } else {
        this.monitorDataList = [];
      }
    },
    
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.getDeviceTable();
    },
    handleCurrentChange(val) {
      this.pagination.current = val;
      this.getDeviceTable();
    },
    resetKeyword() {
      this.formselect = {};
      this.deviceListShow = JSON.parse(JSON.stringify(this.deviceList))
    },
    initEcharts(id, echartData) {
      var Kchart1 = this.$echarts.init(document.getElementById(id));

      var Linecolor = ["#4D9DC6", "#95DBD3", "#A5E893", "#FFE8AA", "#4179A2"];
      var seriesList = [];
      let codeListShow = new Array();
      for (let index = 0; index < echartData.codeList.length; index++) {
        let curCode = "";
        if (this.activeLang == "zh") {
          curCode = this.gatherOption.find(
            (item) => item.name == echartData.codeList[index]
          )?.nameZH;
        } else {
          curCode = this.gatherOption.find(
            (item) => item.name == echartData.codeList[index]
          )?.name;
        }
        codeListShow.push(curCode);
      }

      for (var i = 0; i < echartData.chartDataList.length; i++) {
        var temp = {
          name: echartData.codeList[i],
          type: "line",
          showAllSymbol: true,
          // symbol: "circle",
          symbolSize: 4,
          lineStyle: {
            normal: {
              color: Linecolor[i],
              width: 2,
            },
          },
          label: {
            normal: {
              show: false,
            },
            emphasis: {
              show: true,
              position: "top",
              textStyle: {
                color: Linecolor[i],
              },
            },
          },

          itemStyle: {
            color: Linecolor[i],
            // borderColor: Linecolor[i],
            // borderWidth: 1,
            // shadowColor: "rgba(0, 0, 0, .3)",
            // shadowBlur: 0,
            // shadowOffsetY: 2,
            // shadowOffsetX: 2,
          },
          areaStyle: {
            normal: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "rgba(0,201,255,0.05)" },
                { offset: 1, color: "rgba(0,201,255,0)" },
              ]),
              shadowColor: "rgba(0,201,255, 0.9)",
              shadowBlur: 10,
            },
          },
          data: echartData.chartDataList.find(
            (item) => item.code === echartData.codeList[i]
          )?.dataList,
        };
        seriesList.push(temp);
      }

      var optionK = {
        legend: {
          data: codeListShow,
          textStyle: {
            color: "#999",
            align: "left",
          },
          left: 10,
          top: 10,
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            lineStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(0, 255, 233,0)",
                  },
                  {
                    offset: 0.5,
                    color: "rgba(255, 255, 255,1)",
                  },
                  {
                    offset: 1,
                    color: "rgba(0, 255, 233,0)",
                  },
                ],
                global: false,
              },
            },
          },
          backgroundColor: "#141518", // 提示背景颜色，默认为透明度为0.7的黑色
          borderColor: "rgba(0,0,0,0)",
          textStyle: {
            color: "#828393",
          },
          formatter: (param) => {
            let str = "<div style='margin: 0px 0 0;line-height:1;'>"+
            "<div style='margin: 0px 0 0;line-height:1;'>"+
            "<div style='font-size:10px;color:#828393;font-weight:400;line-height:1;'>" + param[0].axisValue + "</div>" +
            "<div style='margin: 0px 0 0;line-height:1;'>";
            for (let index = 0; index < param.length; index++) {
              let curCode = "";
              if (this.activeLang == "zh") {
                curCode = this.gatherOption.find(
                  (item) => item.name == echartData.codeList[index]
                )?.nameZH;
              } else {
                curCode = this.gatherOption.find(
                  (item) => item.name == echartData.codeList[index]
                )?.name;
              }
              const element = param[index];
              const unit = echartData.chartDataList.find(
                (item) => item.code === element.seriesName
              )?.unit ?? "";
              str += "<div style='margin: 10px 0 0;line-height:1;'>" + 
              "<div style='margin: 0px 0 0;line-height:1;'>"+
              element.marker + 
              "<span style = 'font-size:10px;color:#828393;font-weight:400;margin-left:2px'>" + curCode + "</span>" + 
              "<span style='float:right;margin-left:20px;font-size:10px;color:#828393;font-weight:900'>"+ (element.value+"").parseNum() +"&nbsp" + unit +"<span>" +
              "<div style='clear:both'></div></div> <div style='clear:both'></div></div>"
            }
            str += "<div style='clear:both'></div></div> <div style='clear:both'></div></div> <div style='clear:both'></div></div>"
            return str;
          }
        },
        grid: {
          top: 60,
          left: 40,
          right: 40,
          bottom: 80,
        },
        dataZoom: [
          {
            show: true,
            height: 26,
            xAxisIndex: [0],
            bottom: 20,
            start: 80,
            end: 100,
            textStyle: {
              color: "#A7B7CC",
            },
          },
          {
            type: "inside",
            show: true,
            height: 15,
            start: 1,
            end: 35,
          },
        ],
        xAxis: [
          {
            type: "category",
            axisLine: {
              show: true,
              color: "#999",
              lineStyle: {
                color: "#999",
              },
            },
            splitArea: {
              // show: true,
              color: "#999",
              lineStyle: {
                color: "#999",
              },
            },
            axisLabel: {
              color: "#999",
            },
            splitLine: {
              show: false,
            },
            boundaryGap: false,
            data: echartData.dateTimeList,
          },
        ],

        yAxis: [
          {
            type: "value",
            min: 0,
            // max: 140,
            splitNumber: 4,
            splitLine: {
              show: true,
              lineStyle: {
                color: "rgba(255,255,255,0.1)",
              },
            },
            axisLine: {
              show: false,
            },
            axisLabel: {
              show: false,
              margin: 20,
              textStyle: {
                color: "#d1e6eb",
              },
            },
            axisTick: {
              show: false,
            },
          },
        ],
        series: seriesList,
      };

      Kchart1.setOption(optionK);

      window.addEventListener("resize", () => {
        Kchart1.resize();
      });
    },
  },
};
</script>


